var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1091_41856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1091_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 15.833V14.1663H11.7499C12.6249 14.1663 13.3853 13.8886 14.0312 13.333C14.677 12.7775 14.9999 12.083 14.9999 11.2497C14.9999 10.4163 14.677 9.7219 14.0312 9.16634C13.3853 8.61079 12.6249 8.33301 11.7499 8.33301H6.49992L8.66659 10.4997L7.49992 11.6663L3.33325 7.49967L7.49992 3.33301L8.66659 4.49967L6.49992 6.66634H11.7499C13.0971 6.66634 14.2534 7.10384 15.2187 7.97884C16.1839 8.85384 16.6666 9.94412 16.6666 11.2497C16.6666 12.5552 16.1839 13.6455 15.2187 14.5205C14.2534 15.3955 13.0971 15.833 11.7499 15.833H5.83325Z",
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.512eebbb10eea215f495afefddfaba7e.svg";
export { ForwardRef as ReactComponent };